module.exports = "\n  <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/auth/auth-layout.component.html
// module id = 567
// module chunks = 17